import {useIsAgency, useIsCompany, useIsLoggedIn, useIsSubbrand} from "@/hooks/useUserHooks";
import useUserStore from "@/store/user";
import {usePostHog} from "posthog-js/react";
import {useEffect} from "react";

const usePosthogIdentify = () => {
  const isLoggedin = useIsLoggedIn();
  const posthog = usePostHog();
  const user = useUserStore(state => state.user);
  const email = useUserStore(state => state.user.email);
  const isAgency = useIsAgency();
  const isSubbrand = useIsSubbrand();
  const isCompany = useIsCompany();

  useEffect(() => {
    if (!isLoggedin) return;
    if (user.id && email) {
      const properties: Record<string, unknown> = {email};

      if (isAgency && user.agencies?.length > 0) {
        properties.agency_id = user.agencies.map(a => String(a.id));
      }

      if (isSubbrand && user.sub_brands?.length! > 0) {
        properties.subbrand_id = user.sub_brands?.map(s => String(s.id));
      }

      if (isCompany && user.sub_brands?.length! > 0) {
        properties.company_id = user.sub_brands?.map(c => String(c.id));
      }

      posthog.identify(String(user.id), properties);
    }
  }, [user, email, isSubbrand, isCompany, isAgency]);
};

export {usePosthogIdentify};
